import { isPlatformBrowser } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ApplicationRef, ComponentFactoryResolver, ElementRef, inject, Injectable, Injector, PLATFORM_ID, Renderer2, TemplateRef } from "@angular/core";
import { catchError, map, Subject, throwError } from "rxjs";
import Swal, { SweetAlertPosition } from "sweetalert2";
import { Loader } from "@googlemaps/js-api-loader"
import { Observable, of } from "rxjs";
import { environment } from '../../environments/environment';
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { ToastComponent } from "libs/shared/src/lib/toast/toast.component";
@Injectable({
  providedIn: "root",
})
export class HelpersService {

  public onResetAutoInitHS = new Subject<any>();
  onResetAutoInitHS$ = this.onResetAutoInitHS.asObservable();
  private projectName = 'mu';
  public storageAccessTokenKey = this.projectName + '-access-token';

  platformId = inject(PLATFORM_ID);

  get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  public handleError(error: Response) {
    switch (error.status) {
    }
    return throwError(error);
  }

  constructor(private http: HttpClient,
    private injector: Injector,
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver

  ) { }

  private addAngularComponentToSwal(title: string, content :string, type: string) {
    const container = document.getElementById('toast-container');
    if (container) {
      this.createComponent(container, title, content, type);
    }
  }

  private createComponent(container: HTMLElement, title: string, content :string, type: string) {
    // Creiamo il componente con la factory
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(ToastComponent).create(this.injector);
    if(title || content && type){
      componentRef.instance.content = content ? content : ''
      componentRef.instance.title = title ? title : ''
      componentRef.instance.type = type
    }
    // Aggiungiamo il componente al ciclo di vita di Angular
    this.appRef.attachView(componentRef.hostView);

    // Aggiungiamo il componente al DOM di SweetAlert2
    container.appendChild(componentRef.location.nativeElement);
  }

  public showToast(title: string, message: string = '', type: string = 'error', position: SweetAlertPosition = 'bottom-start') {
    const closeButton = false;
    const timer = 3000;

    const Toast = Swal.mixin({
      toast: true,
      background: 'transparent',
      position: position,
      customClass: {
        popup: 'api-res-toast !shadow-nonen',
        icon: 'border-0',
      },
      showConfirmButton: false,
      showCloseButton: closeButton,
      timer: timer,
      timerProgressBar: false,
      html: '<div id="toast-container"></div>',
      willOpen: () => {
        this.addAngularComponentToSwal(title, message, type);
      }
    })
    Toast.fire()
  }

  public generateRandomId() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 16) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  public sendContact(req: any) {
    return this.http.post(`https://reqres.in/api/users/2`, req).pipe(
      map((res: any) => {
        res.idFlow = 1234;
        return res;
      }),
      catchError(error => {
        return this.handleError(error);
      })
    )
  }

  public consentsAccepted(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return { notAllowed: true }
    }
    return null;
  }

  public isEqualObj(value: any, other: any) {
    if (typeof value !== "object" && typeof other !== "object") {
      return Object.is(value, other);
    }

    if (value === null && other === null) {
      return true;
    }

    if (typeof value !== typeof other) {
      return false;
    }

    if (value === other) {
      return true;
    }

    if (Object.keys(value).length !== Object.keys(other).length) {
      return false;
    }

    for (const [k, v] of Object.entries(value)) {
      if (!(k in other)) {
        return false;
      }
    }

    return true;
  }

  public saveAccessToken(accessToken: any) {
    localStorage.setItem(this.storageAccessTokenKey, accessToken);
   // localStorage.setItem(this.storageRefreshTokenKey, res.refresh_token);

    //const expiresIn = String((new Date().valueOf()) + (res.expires_in * 0.95 * 1000));
   // localStorage.setItem(this.storageExpiresIn, expiresIn);
   //  let date = new Date();
   //  date.setDate( date.getDate() + this.daysExpireRefreshToken );
   //  localStorage.setItem(this.storageExpiresInRefreshToken, String(date.valueOf()));

  }

  get accessToken(): string {
    return <string>localStorage.getItem(this.storageAccessTokenKey);
  }

  public getHTTPHeader() {
    if (!this.accessToken) {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
    } else {
      let token: string = this.accessToken;
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        })
      };
    }
  }

}
